import type { CaseShellMode } from "@/components/case-checking/CaseReviewShell";
import type { ReviewWorkflowStep } from "@/components/case-checking/CaseReviewWorkflow";

export type CaseDetailEntryTab =
  | "summary"
  | "documents"
  | "timeline"
  | "completeness"
  | "assessment"
  | "inconsistencies"
  | "remedial"
  | "artefacts"
  | "adjudication";

/** Where to land when opening a case from the list or a deep link. */
export type CaseOpenIntent = {
  shellMode?: CaseShellMode;
  workflowStep?: ReviewWorkflowStep;
  detailTab?: CaseDetailEntryTab;
};

export const CASE_OPEN_SUMMARY: CaseOpenIntent = { shellMode: "summary" };

export const CASE_OPEN_REVIEW: CaseOpenIntent = {
  shellMode: "review",
  workflowStep: "narrative",
};
